'use strict';

/**
 * @pbdoc Directive
 * @name rmTime
 * @packageName time-dir
 *
 * @description
 *
 * Split time into separete hours / minutes / seconds
 *
 */
class rmTime {

    constructor() {

        //Attributes
        this.restrict = 'A';
        this.require = '?ngModel';
    }

    /*
     * Connection to dom element
     * !! Classic function because this represents  null !!
     *
     * @Param {Object} scope of the Modelview
     * @Param {Object} element binding with view
     * @Param {Array} attributes of the element
     * @Param {Object} ngModel binding
     */
    link($scope, element, attributes, ngModelCtrl) {
        function toViewValue(value) {
            //Declarables
            let time = value || 0,
                getMinutes = Math.floor(time / 60).toString(),
                getSeconds = (time - getMinutes * 60).toString();

            //Add a zero if number is under 10
            let minutes = getMinutes.length <= 1 ? '0' + getMinutes : getMinutes;
            let seconds = getSeconds.length <= 1 ? '0' + getSeconds : getSeconds;

            return minutes + ':' + seconds;
        }

        function toSeconds(viewValue) {

            if(!viewValue) {

                return 0;
            }

            let time = viewValue.split(':'),
                minutes = parseInt(time[0], 10),
                seconds = parseInt(time[1], 10);

            return (minutes * 60) + seconds;
        }

        if(attributes.ngModel) {
            //Format incomming number of seconds
            ngModelCtrl.$formatters.push(toViewValue);

            //Turns view input mm:ss format into seconds
            ngModelCtrl.$parsers.push(toSeconds);

            //Minimum time
            ngModelCtrl.$validators.minSeconds = function(modelValue, viewValue) {

                return (attributes.minInSeconds && modelValue >= parseInt(attributes.minInSeconds, 10)) || true;
            };

            //Maximum time
            ngModelCtrl.$validators.maxSeconds = function(modelValue, viewValue) {

                return (attributes.maxInSeconds && modelValue <= parseInt(attributes.maxInSeconds, 10)) || true;
            };


            element.keydown((e) => {
                if(e.keyCode == 40 || e.keyCode == 38) {
                    e.preventDefault();
                    let changeSize = e.ctrlKey ? 60 : 1;

                    let seconds = 0;
                    if(e.keyCode == 40) {
                        seconds = toSeconds(ngModelCtrl.$viewValue) - changeSize;
                    } else if(e.keyCode == 38) {
                        seconds = toSeconds(ngModelCtrl.$viewValue) + changeSize;
                    }
                    ngModelCtrl.$setViewValue(toViewValue(seconds));
                    ngModelCtrl.$render();
                }
            });
        }
    }
}

/*
 * Browsify connection: execute service
 * @Return {Object} A new instance of this directive
 */
module.exports = [() => {

    //Create new instance
    rmTime.instance = new rmTime();
    return rmTime.instance;
}];